const CLIENT_LOGOS_ROW1 = [
  { name: 'P&G', url: 'https://www.ezeefit.in/images/Clientele/p-g.png' },
  { name: 'Gillette', url: 'https://www.ezeefit.in/images/Clientele/gillete.png' },
  { name: 'L&T', url: 'https://www.ezeefit.in/images/Clientele/L-T-logo.jpg' },
  { name: 'HPCL', url: 'https://www.ezeefit.in/images/Clientele/HPCL-Hindustan-Petroleum-Corporation.jpg' },
  { name: 'Ultratech Cement', url: 'https://www.ezeefit.in/images/Clientele/Ultratech-Cement.jpg' },
  { name: 'T-Series', url: 'https://www.ezeefit.in/images/Clientele/t-series-logo.png' },
  { name: 'Crompton Greaves', url: 'https://www.ezeefit.in/images/Clientele/Crompton-Greaves.jpg' },
  { name: 'Mother Dairy', url: 'https://www.ezeefit.in/images/Clientele/mother-dairy.jpg' },
  { name: 'Awfis', url: 'https://www.ezeefit.in/images/Clientele/awfis.png' },
  { name: 'D2H', url: 'https://www.ezeefit.in/images/Clientele/D2H.jpg' },
];

const CLIENT_LOGOS_ROW2 = [
  { name: 'Indian Bank', url: 'https://www.ezeefit.in/images/clients/indianb.jpg' },
  { name: 'Bombay Mercantile Bank', url: 'https://www.ezeefit.in/images/Clientele/bombay-mercantile-bank-logo.jpg' },
  { name: 'Nodwin', url: 'https://www.ezeefit.in/images/Clientele/nodwin.jpg' },
  { name: 'Blenheim Chalcot', url: 'https://www.ezeefit.in/images/Clientele/blenheim.jpg' },
  { name: 'Valuelabs', url: 'https://www.ezeefit.in/images/Clientele/valuelabs.jpg' },
  { name: 'Safe Express', url: 'https://www.ezeefit.in/images/Clientele/safexpress-logo.png' },
  { name: 'Kuoni', url: 'https://www.ezeefit.in/images/Clientele/kuoni.jpg' },
  { name: 'Nippon', url: 'https://www.ezeefit.in/images/Clientele/Nippon.jpg' },
  { name: 'Wizcraft', url: 'https://www.ezeefit.in/images/Clientele/WIZCRAFT.jpg' },
  { name: 'Eveready', url: 'https://www.ezeefit.in/images/Clientele/EVERYREADY.jpg' },
];

export function ClientFootprintSection() {
  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="container mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="text-sm font-bold text-primary uppercase tracking-widest mb-3">
            Trusted by Industry Leaders Since 2014
          </p>
          <h2 className="text-3xl md:text-4xl font-black uppercase mb-4 text-foreground">
            Over 10 Years of Furnishing India's Most Productive Workspaces
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            While this store is new, our commitment to quality is a decade strong. We've delivered customized solutions to over <span className="font-bold text-foreground">5,000+ offices</span> through <span className="text-primary font-semibold">www.ezeefitofficesystems.in</span>.
          </p>
        </div>

        {/* Logo Carousel */}
        <div className="relative mb-12">
          {/* Gradient overlays for fade effect */}
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10"></div>
          
          {/* Scrolling container - Row 1 */}
          <div className="flex animate-scroll mb-6">
            {[...CLIENT_LOGOS_ROW1, ...CLIENT_LOGOS_ROW1].map((client, index) => (
              <div key={index} className="flex items-center gap-12 px-6">
                <img 
                  src={client.url} 
                  alt={client.name}
                  className="h-12 md:h-16 w-auto object-contain grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300"
                />
              </div>
            ))}
          </div>

          {/* Scrolling container - Row 2 (reverse direction) */}
          <div className="flex animate-scroll-reverse">
            {[...CLIENT_LOGOS_ROW2, ...CLIENT_LOGOS_ROW2].map((client, index) => (
              <div key={index} className="flex items-center gap-12 px-6">
                <img 
                  src={client.url} 
                  alt={client.name}
                  className="h-12 md:h-16 w-auto object-contain grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300"
                />
              </div>
            ))}
          </div>
        </div>

        {/* By the Numbers - Trust Bar */}
        <div className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 rounded-2xl p-8 mb-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center text-white">
            <div className="border-r border-white/20 last:border-r-0">
              <div className="text-3xl md:text-4xl font-black text-primary mb-1">10+</div>
              <p className="text-xs md:text-sm text-slate-300 uppercase tracking-wide">Years of Manufacturing Excellence</p>
            </div>
            <div className="border-r border-white/20 last:border-r-0 md:border-r">
              <div className="text-3xl md:text-4xl font-black text-primary mb-1">5,000+</div>
              <p className="text-xs md:text-sm text-slate-300 uppercase tracking-wide">Office Spaces Furnished</p>
            </div>
            <div className="border-r border-white/20 last:border-r-0">
              <div className="text-3xl md:text-4xl font-black text-primary mb-1">1,00,000+</div>
              <p className="text-xs md:text-sm text-slate-300 uppercase tracking-wide">Desks Delivered</p>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-black text-primary mb-1">🇮🇳</div>
              <p className="text-xs md:text-sm text-slate-300 uppercase tracking-wide">Pan-India Logistics Network</p>
            </div>
          </div>
        </div>

        {/* Legacy Link - The Bridge */}
        <div className="text-center">
          <div className="inline-flex flex-col md:flex-row items-center gap-4 bg-gradient-to-r from-red-50 to-orange-50 border border-red-200 rounded-xl px-8 py-5">
            <p className="text-gray-700 font-medium">
              Looking for our custom corporate portfolio? Visit <span className="text-red-700 font-bold">www.ezeefitofficesystems.in</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
